var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", [_vm._v("设施运维")]),
              _c("el-breadcrumb-item", [_vm._v("运维管理")]),
              _c("el-breadcrumb-item", [_vm._v("综合维保")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "150px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单ID" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单ID" },
                              model: {
                                value: _vm.searchForm.TicketId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "TicketId", $$v)
                                },
                                expression: "searchForm.TicketId"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.activeTab === "subMaintenanceDetail"
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "主单ID" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入主单ID" },
                                  model: {
                                    value: _vm.searchForm.MainTicketId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchForm,
                                        "MainTicketId",
                                        $$v
                                      )
                                    },
                                    expression: "searchForm.MainTicketId"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.CampusName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "CampusName", $$v)
                                  },
                                  expression: "searchForm.CampusName"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "张家口-怀来瑞北",
                                    value: "张家口-怀来瑞北"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "清远-清新",
                                    value: "清远-清新"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "清远-清城",
                                    value: "清远-清城"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "深圳-滨海腾大",
                                    value: "深圳-滨海腾大"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "贵阳-贵安七星",
                                    value: "贵阳-贵安七星"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "天津-滨海高新",
                                    value: "天津-滨海高新"
                                  }
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "南京-江宁",
                                    value: "南京-江宁"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "计划开始时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.createTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "createTime", $$v)
                                },
                                expression: "searchForm.createTime"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ])
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-tabs",
        {
          staticClass: "custom-tabs",
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "综合维保主单", name: "maintenance" } },
            [
              _c("div", { staticClass: "title-en" }, [_vm._v("综合维保列表")]),
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "button-container" },
                      [
                        _c(
                          "el-button",
                          { on: { click: _vm.openColumnsDialog } },
                          [_vm._v("表头设置")]
                        ),
                        _c(
                          "el-button",
                          { on: { click: _vm.debouncedExport } },
                          [_vm._v(_vm._s(_vm.exportButtonText))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        ref: "table",
                        attrs: { data: _vm.tableData, border: "", stripe: "" },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "55",
                            align: "center"
                          }
                        }),
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: "序号",
                            width: "60",
                            align: "center"
                          }
                        }),
                        _vm._l(_vm.visibleColumns, function(column, index) {
                          return _c("el-table-column", {
                            key: index,
                            attrs: {
                              prop: column.prop,
                              label: column.label,
                              width: column.width,
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      [
                                        "TicketStartDate",
                                        "PlanStartDate",
                                        "PlanEndDate",
                                        "EndDate"
                                      ].includes(column.prop)
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[column.prop]
                                                  ? _vm
                                                      .$moment(
                                                        scope.row[column.prop]
                                                      )
                                                      .format(
                                                        "YYYY-MM-DD HH:mm:ss"
                                                      )
                                                  : "-"
                                              )
                                            )
                                          ])
                                        : column.prop === "SubTicket"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleSubTicketClick(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("查看子单")]
                                          )
                                        : column.prop === "ToolsList"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.ToolsList == "null"
                                                    ? "-"
                                                    : scope.row.ToolsList
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : column.prop === "Item"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.Item == "[]"
                                                    ? "-"
                                                    : scope.row.Item
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[column.prop] || "-"
                                              )
                                            )
                                          ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        })
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "pagination-container" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "page-sizes": [10, 20, 30, 50],
                            "page-size": _vm.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.total
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "综合维保子单", name: "subMaintenanceDetail" } },
            [
              _vm.activeTab === "subMaintenanceDetail"
                ? _c("subMaintenanceDetail", { ref: "subMaintenanceDetailRef" })
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "综合维保维修", name: "maintenance-repair" } },
            [
              _vm.activeTab === "maintenance-repair"
                ? _c("maintenance-repair", { ref: "repairRef" })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置显示项",
            visible: _vm.showColumnsDialog,
            "append-to-body": true,
            width: "400px",
            "close-on-click-modal": false,
            "custom-class": "columns-dialog",
            "modal-append-to-body": false,
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.showColumnsDialog = $event
            }
          }
        },
        [
          _c(
            "el-checkbox-group",
            {
              staticClass: "checkbox-group",
              model: {
                value: _vm.selectedColumns,
                callback: function($$v) {
                  _vm.selectedColumns = $$v
                },
                expression: "selectedColumns"
              }
            },
            _vm._l(_vm.columns, function(column) {
              return _c(
                "el-checkbox",
                {
                  key: column.prop,
                  staticClass: "checkbox-item",
                  attrs: { label: column.prop }
                },
                [_vm._v("\n        " + _vm._s(column.label) + "\n      ")]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.selectAllColumns }
                },
                [_vm._v("全选")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.restoreDefaultColumns }
                },
                [_vm._v("恢复默认")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.saveColumnsDialog }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "子单列表",
            visible: _vm.subTicketDialogVisible,
            width: "90%",
            "before-close": _vm.handleSubTicketDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.subTicketDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "search-container",
              staticStyle: { "margin-bottom": "20px" }
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { model: _vm.subTicketSearchForm }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "时间范围" } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.handleSubTicketDateChange },
                                model: {
                                  value: _vm.subTicketSearchForm.createTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.subTicketSearchForm,
                                      "createTime",
                                      $$v
                                    )
                                  },
                                  expression: "subTicketSearchForm.createTime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "search-button" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.handleSubTicketSearch }
                              },
                              [_vm._v("查询")]
                            ),
                            _c(
                              "el-button",
                              { on: { click: _vm.handleSubTicketReset } },
                              [_vm._v("重置")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { loading: _vm.subTicketExportLoading },
                                on: { click: _vm.handleSubTicketExport }
                              },
                              [_vm._v(_vm._s(_vm.subTicketExportButtonText))]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadings,
                  expression: "loadings"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.subTicketList,
                border: "",
                "max-height": "500px"
              },
              on: { "selection-change": _vm.handleSubTicketSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" }
              }),
              _c("el-table-column", {
                attrs: { prop: "TicketId", label: "工单号", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MainTicketId",
                  label: "主流程工单号",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "StartTime", label: "开始时间", width: "200" }
              }),
              _c("el-table-column", {
                attrs: { prop: "ProcessTitle", label: "标题", width: "580" }
              }),
              _c("el-table-column", {
                attrs: { prop: "CampusName", label: "园区名称", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "MozuName", label: "模组名称", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "DeviceUid", label: "设备uid", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "DeviceName", label: "设备名称", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "DeviceNumber", label: "设备编号", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "Professional", label: "专业", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "DealUser", label: "负责人", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "EndTime", label: "结束时间", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "AbnormalCheckCount",
                  label: "异常计数",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "StatusLight", label: "状态灯", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MaintainSummary",
                  label: "维护总结",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "Confirm", label: "确认结单状态", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "StandardTime", label: "标准耗时", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TimeConsuming",
                  label: "实际耗时",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "DevicetypesName",
                  label: "维护项目名称",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ApplicationTypeName",
                  label: "应用类型",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "TicketStatus", label: "工单状态", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "Maintainer", label: "服务商", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "AuditResults",
                  label: "工单审核结果",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "AuditReason", label: "审核原因", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "TimeOut", label: "是否超时", width: "150" }
              }),
              _c("el-table-column", {
                attrs: { prop: "CheckInTime", label: "打卡时间", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CheckInStatus",
                  label: "打卡状态",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "CheckInPlace", label: "打卡地点", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MaintenanceType",
                  label: "维护类型",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MaintenanceCycle",
                  label: "维护周期",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "PTicketId",
                  label: "问题跟进单号",
                  width: "150"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "PInsId", label: "问题跟进流程id", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "UploadStart",
                  label: "上传图片开始",
                  width: "150",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "UploadEnd",
                  label: "上传图片结束",
                  width: "150"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.UploadEnd === "null"
                                ? "-"
                                : scope.row.UploadEnd
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.subTicketCurrentPage,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.subTicketPageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.subTicketTotal
                },
                on: {
                  "size-change": _vm.handleSubTicketSizeChange,
                  "current-change": _vm.handleSubTicketCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }